export default "__VITE_ASSET__C9onGiJj__"